"use client";

// 1. React and Next.js core imports
import Link from "next/link";

// 2. Global styles
// (none)

// 3. Providers/Context
// (none)

// 4. Components
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import useLogin from "@/components/hooks/login/useLogin.hook";
import { Eye, EyeOff, LoaderCircle } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation.hook";

const LoginForm = () => {
  const {
    form,
    onSubmit,
    loginLoading,
    showPassword,
    togglePasswordVisibility,
  } = useLogin();
  const { t } = useTranslation();
  return (
    <>
      {/* <div className="flex items-center justify-center min-h-screen">
                <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md"> */}
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-3 sm:space-y-4"
        >
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel data-testid="login-email-label">
                  メールアドレス
                </FormLabel>
                {/* <FormLabel>Username</FormLabel> */}
                <FormControl>
                  <Input
                    // type="email"
                    placeholder="demo@opentakt.com"
                    {...field}
                    data-testid="login-email-input"
                  />
                </FormControl>
                <FormMessage data-testid="login-email-error" t={t} />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="password"
            render={({ field }) => (
              <FormItem>
                <FormLabel data-testid="login-password-label">
                  パスワード
                </FormLabel>
                {/* <FormLabel>Password</FormLabel> */}
                <FormControl>
                  <div className="relative">
                    <Input
                      type={showPassword ? "text" : "password"}
                      placeholder="パスワードを入力"
                      {...field}
                      data-testid="login-password-input"
                    />
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
                      onClick={togglePasswordVisibility}
                      data-testid="login-password-toggle"
                    >
                      {showPassword ? (
                        <Eye
                          className="h-4 w-4"
                          data-testid="login-password-eye-icon"
                        />
                      ) : (
                        <EyeOff
                          className="h-4 w-4"
                          data-testid="login-password-eye-off-icon"
                        />
                      )}
                    </Button>
                  </div>
                </FormControl>
                <FormMessage data-testid="login-password-error" t={t} />
              </FormItem>
            )}
          />

          <Button
            type="submit"
            className="w-full"
            disabled={loginLoading}
            data-testid="login-submit-button"
          >
            {loginLoading && (
              <LoaderCircle
                className="animate-spin mr-2 h-4 w-4"
                data-testid="login-loading-spinner"
              />
            )}
            ログイン
          </Button>
          <p className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            パスワードをお忘れですか？
            <Link
              href="/forgot-password"
              className="text-primary"
              data-testid="forgot-password-link"
            >
              パスワードをリセット
            </Link>
          </p>
        </form>
      </Form>
      {/* </div>
            </div> */}
    </>
  );
};

export default LoginForm;
